import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  corporationData: {
    info: {},
  },
  userConfig: {
    loading: false,
    logged: false,
    userData: {},
    language: "es",
    literals: [],
    rol: null,
    token: null,
    componentActive: "orders",
    lastComponentActive: "",
    datatable: {
      configuration: { maxRows: 12, indexStart: 0, pages: [0], filterBy: { section: "", filter: [] } },
      checkColumn: false,
    },
    alerts: [],
    floatPanel: {
      visible: false,
      component: null,
    },
    order: {},
    request: {
      payment: {
        total: 0,
        received: 0,
        missing: 0,
        change: 0,
      },
      activePayments: [],
    },
  },
};

const userConfigSlice = createSlice({
  name: "aplicationConfig",
  initialState,
  reducers: {
    setAlert: (state, action) => {
      const id = new Date().getTime(); // ID único basado en el tiempo
      state.userConfig.alerts.push({ id, ...action.payload });
    },
    removeAlert: (state, action) => {
      state.userConfig.alerts = state.userConfig.alerts.filter((alert) => alert.id !== action.payload);
    },
    setLoading: (state, action) => {
      state.userConfig.loading = action.payload;
    },
    setCorporationData: (state, action) => {
      state.corporationData.info = action.payload;
    },
    setUserData: (state, action) => {
      state.userConfig.userData = action.payload;
    },
    setUserLogged: (state, action) => {
      state.userConfig.logged = action.payload;
    },
    setUserLogOut: (state) => {
      state.userConfig.logged = false;
      state.userConfig.token = null;
      state.userConfig.userData = {};
      state.userConfig.rol = null;
      state.userConfig.order = {};
      state.userConfig.componentActive = "";
      state.userConfig.lastComponentActive = "";
      state.userConfig.request = initialState.userConfig.request;
      state.userConfig.floatPanel = initialState.userConfig.floatPanel;
    },
    setUserLanguage: (state, action) => {
      state.userConfig.language = action.payload;
    },
    setLanguage: (state, action) => {
      state.userConfig.literals = action.payload;
    },
    setUserRol: (state, action) => {
      state.userConfig.rol = action.payload;
    },
    setToken: (state, action) => {
      state.userConfig.token = action.payload;
      state.userConfig.logged = true;
    },
    setComponentActive: (state, action) => {
      state.userConfig.floatPanel.visible = false;
      state.userConfig.componentActive = action.payload;
    },
    setLastComponentActive: (state, action) => {
      state.userConfig.lastComponentActive = action.payload;
    },
    updateDatatableConfiguration: (state, action) => {
      state.userConfig.datatable.configuration = action.payload;
    },
    updateDatatableFilter: (state, action) => {
      const { section, filter } = action.payload;
      state.userConfig.datatable.configuration.filterBy.section = section;
      state.userConfig.datatable.configuration.filterBy.filter = filter;
    },
    updateDatatableCheckColumn: (state, action) => {
      state.userConfig.datatable.checkColumn =
        typeof action.payload === "boolean" ? action.payload : !state.userConfig.datatable.checkColumn;
    },
    updateFloatPanelVisibility: (state) => {
      state.userConfig.floatPanel.visible = !state.userConfig.floatPanel.visible;
    },
    setFloatPanelComponent: (state, action) => {
      state.userConfig.floatPanel.component = action.payload;
    },
    setOrder: (state, action) => {
      state.userConfig.order = action.payload;
    },
    updateRequestPayments: (state, action) => {
      const { total = 0, received = 0, missing = 0, change = 0 } = action.payload;
      state.userConfig.request.payment = {
        total,
        received,
        missing,
        change,
      };
    },

    updateRequestActivePayments: (state, action) => {
      const { paymentMethodId, value } = action.payload;
      const existingPayment = state.userConfig.request.activePayments.find(
        (payment) => payment.paymentMethodId === paymentMethodId,
      );

      if (existingPayment) {
        existingPayment.value = value; // Actualiza el valor si ya existe
      } else {
        state.userConfig.request.activePayments.push(action.payload); // Agrega si no existe
      }
    },

    removeRequestActivePayments: (state, action) => {
      const { paymentMethodId } = action.payload;

      state.userConfig.request.activePayments = state.userConfig.request.activePayments.filter(
        (payment) => payment.paymentMethodId !== paymentMethodId,
      );
    },

    addRequestActivePayments: (state, action) => {
      const { paymentMethodId } = action.payload;
      const existingPayment = state.userConfig.request.activePayments.find(
        (payment) => payment.paymentMethodId === paymentMethodId,
      );

      if (!existingPayment) {
        state.userConfig.request.activePayments.push(action.payload); // Agrega si no existe
      }
    },

    initRequestPayments: (state) => {
      state.userConfig.request.activePayments = [];
      state.userConfig.request.payment = {
        total: 0,
        received: 0,
        missing: 0,
        change: 0,
      };
    },
  },
});

export const {
  setLoading,
  setUserLogged,
  setUserLanguage,
  setLanguage,
  setUserRol,
  setCorporationData,
  setComponentActive,
  updateDatatableConfiguration,
  setToken,
  setUserData,
  setUserLogOut,
  setAlert,
  removeAlert,
  updateDatatableFilter,
  updateDatatableCheckColumn,
  updateFloatPanelVisibility,
  setFloatPanelComponent,
  setOrder,
  setLastComponentActive,
  updateRequestPayments,
  updateRequestActivePayments,
  addRequestActivePayments,
  removeRequestActivePayments,
  initRequestPayments,
} = userConfigSlice.actions;
export default userConfigSlice.reducer;
